import { Box, Flex, Grid } from '@mantine/core';
import { FC } from 'react';
import { InputText } from 'src/components/Form/Text';
import { InputDateTimePicker } from 'src/components/Form/DateTimePicker';
import { Select } from 'src/components/Form/Select';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { Form } from 'src/form';
import { ActionFooter } from 'src/components/ActionFooter';
import { FormData, useAddCampaign } from './use-add-campaign';

export const AddCampaign: FC = () => {
  const {
    isPending,
    onSubmit,
    onCancel,
    initialValues,
    validate,
    campaignTypeOptions,
    campaignGoalOptions,
    locationTypeOptions,
  } = useAddCampaign();

  return (
    <Form<FormData>
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
    >
      <Flex
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Box>
          <PageTitle title="Add Campaign" />
          <PageLoader visible={isPending} />
          <Grid>
            <Grid.Col span={6}>
              <InputText
                name="name"
                label="Campaign Name"
                placeholder="Enter campaign name"
              />
            </Grid.Col>

            <Grid.Col span={6} />

            <Grid.Col span={6}>
              <InputDateTimePicker
                name="date_from"
                label="Start Date"
                placeholder="Select start date"
                minDate={new Date()}
              />
            </Grid.Col>

            <Grid.Col span={6}>
              <InputDateTimePicker
                name="date_to"
                label="End Date"
                placeholder="Select end date"
                minDate={new Date()}
              />
            </Grid.Col>

            <Grid.Col span={6}>
              <Select
                name="campaign_type"
                label="Campaign Type"
                placeholder="Select campaign type"
                data={campaignTypeOptions}
              />
            </Grid.Col>

            <Grid.Col span={6}>
              <Select
                name="campaign_goal"
                label="Campaign Goal"
                placeholder="Select campaign goal"
                data={campaignGoalOptions}
              />
            </Grid.Col>

            <Grid.Col span={6}>
              <Select
                name="location_type"
                label="Location Type"
                placeholder="Select location type"
                data={locationTypeOptions}
              />
            </Grid.Col>

            <Grid.Col span={6} />
          </Grid>
        </Box>

        <ActionFooter
          onCancel={onCancel}
          submitButton="CREATE"
          isLoading={isPending}
        />
      </Flex>
    </Form>
  );
};
